
export const text = `[ID: A photo of a party inside a small studio apartment. There is a homemade banner hanging from the wall, with the words “Happy Everybirth”. The camera appears to be on top of a table. Four people are posing next to a pizza split evenly into five different topping combinations. There are four birthday candles on the pizza. The fifth one is still in the box. Everyone seems happy.]

http://farragofiction.com/TwoGayJokes/


`